export default __webpack_public_path__ + "static/media/bajaj.0cc9399e.svg";